import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewPlanificacionCamion = () => import('./Planificacion/Index')
const ViewRecepcionCamion = () => import('./Recepcion/Index')
const ViewPlanificacionCamionSalida = () => import('./PlanificacionSalida/Index')
const ViewSalidaCamion = () => import('./Salida/Index')
const ViewReporteCamion = () => import('./Reporte/Index')
const ViewTransferirWC = () => import('./Transferir/Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'planificacion_camion',
        name: 'Planificacion Camion',
        component: ViewPlanificacionCamion,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
      {
        path: 'recepcion_camion',
        name: 'Recepcion Camion',
        component: ViewRecepcionCamion,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },      
      {
        path: 'planificacion_camion_salida',
        name: 'Planificacion Salida Camion',
        component: ViewPlanificacionCamionSalida,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
      {
        path: 'salida_camion',
        name: 'Salida Camion',
        component: ViewSalidaCamion,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },  
      {
        path: 'camion_reporte',
        name: 'Reporte Camion',
        component: ViewReporteCamion,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
      {
        path: 'transferir_wc',
        name: 'Transferir WC',
        component: ViewTransferirWC,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },                  
    ],
  },
]

export default router
